import { createFileRoute } from '@tanstack/react-router';
import { EmployeesBeneficiariesPage } from '@/features/beneficiaries/employees-beneficiaries/EmployeesBeneficiariesPage';

export const Route = createFileRoute('/$commiteeSlug/beneficiaries/employees-beneficiaries/{-$id}')(
  {
    component: EmployeesBeneficiariesPage,
  }
);
